import {Application} from '@hotwired/stimulus';
import BackToTopController from './controllers/back_to_top_controller.js';
import HeroMotionController from './controllers/hero_motion_controller.js';
import NavigationController from './controllers/navigation_controller.js';
import PathStoryController from './controllers/path_story_controller.js';
import RevealController from './controllers/reveal_controller.js';
import SmoothScrollController from './controllers/smooth_scroll_controller.js';

const application = Application.start();

application.register('back-to-top', BackToTopController);
application.register('hero-motion', HeroMotionController);
application.register('navigation', NavigationController);
application.register('path-story', PathStoryController);
application.register('reveal', RevealController);
application.register('smooth-scroll', SmoothScrollController);
